export default "__VITE_ASSET__fsb8dnv___"